(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["klimtec-contact-form"] && !Shopify.designMode) return;
  try {
    
  class KlimtecContactForm extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-topic]'));
      this.topicField = this.querySelector('[data-topic-field]');
      this.detailLabel = this.querySelector('[data-detail-label-out]');
      this.detailSelect = this.querySelector('[data-detail-select]');
      this.deviceLabel = this.querySelector('[data-device-label-out]');
      this.deviceInput = this.querySelector('[data-device-input]');
      this.messageInput = this.querySelector('[data-message-input]');

      if (!this.tabs.length) return;

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.select(tab));
      });

      this.presetCity();

      const active = this.tabs.find((tab) => tab.getAttribute('aria-pressed') === 'true') || this.tabs[0];
      this.apply(active);
    }

    /* Kommt der Besucher vom PLZ-Check einer anderen Seite, steht die
       Postleitzahl als Parameter in der Adresse. */
    presetCity() {
      const city = this.querySelector("[data-city-input]");
      if (!city || city.value.trim() !== "") return;
      const params = new URLSearchParams(window.location.search);
      const preset = String(params.get("plz") || "").replace(/\D/g, "").slice(0, 5);
      if (preset.length === 5) city.value = preset + " ";
    }

    select(tab) {
      this.tabs.forEach((other) => other.setAttribute('aria-pressed', other === tab ? 'true' : 'false'));
      this.apply(tab);
    }

    /* Beschriftungen, Auswahl und Platzhalter richten sich nach dem
       gewaehlten Anliegen. So bleibt das Formular kurz und fragt nur,
       was fuer das Angebot wirklich gebraucht wird. */
    apply(tab) {
      const data = tab.dataset;

      if (this.topicField) this.topicField.value = data.topicLabel || '';

      if (this.detailLabel) this.detailLabel.textContent = data.detailLabel || '';

      if (this.detailSelect) {
        const options = String(data.detailOptions || '')
          .split('\n')
          .map((value) => value.trim())
          .filter(Boolean);
        this.detailSelect.innerHTML = '';
        options.forEach((value) => {
          const option = document.createElement('option');
          option.value = value;
          option.textContent = value;
          this.detailSelect.appendChild(option);
        });
        this.detailSelect.hidden = options.length === 0;
        if (this.detailLabel) this.detailLabel.hidden = options.length === 0;
      }

      if (this.deviceLabel) this.deviceLabel.textContent = data.deviceLabel || '';
      if (this.deviceInput) this.deviceInput.placeholder = data.devicePlaceholder || '';
      if (this.messageInput) this.messageInput.placeholder = data.messagePlaceholder || '';
    }
  }

  if (!customElements.get('klimtec-contact-form')) {
    customElements.define('klimtec-contact-form', KlimtecContactForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["klimtec-plz-check"] && !Shopify.designMode) return;
  try {
    
  class KlimtecPlzCheck extends HTMLElement {
    connectedCallback() {
      try {
        this.zones = JSON.parse(this.dataset.zones || '[]');
      } catch (error) {
        this.zones = [];
      }

      this.input = this.querySelector('[data-plz-input]');
      this.button = this.querySelector('[data-plz-submit]');
      this.hint = this.querySelector('[data-plz-hint]');
      this.ok = this.querySelector('[data-plz-ok]');
      this.warn = this.querySelector('[data-plz-warn]');
      this.okTitle = this.querySelector('[data-plz-ok-title]');
      this.okBody = this.querySelector('[data-plz-ok-body]');
      this.warnTitle = this.querySelector('[data-plz-warn-title]');

      if (!this.input || !this.button) return;

      this.button.addEventListener('click', () => this.check());

      this.input.addEventListener('input', () => {
        this.input.value = this.input.value.replace(/\D/g, '').slice(0, 5);
        this.reset();
      });

      this.input.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          this.check();
        }
      });
    }

    reset() {
      [this.hint, this.ok, this.warn].forEach((element) => {
        if (element) element.hidden = true;
      });
    }

    fill(template, plz, zone) {
      return (template || '')
        .replace(/\{plz\}/g, plz)
        .replace(/\{zone\}/g, zone ? zone.label : '')
        .replace(/\{fee\}/g, zone ? zone.fee : '');
    }

    /* Haengt die gepruefte Postleitzahl an die weiterfuehrenden Links,
       damit das Anfrageformular auf der Zielseite sie uebernehmen kann. */
    /* Steht auf derselben Seite ein Ortsfeld, wird es direkt gefuellt.
       Dann braucht es keinen Seitenwechsel und keinen Parameter in der
       Adresse. Nur bei Links auf eine andere Seite wird die PLZ
       angehaengt, damit das Formular dort davon weiss. */
    carryPlz(plz) {
      const local = document.querySelector('[data-city-input]');
      if (local && local.value.trim() === '') local.value = plz + ' ';

      this.querySelectorAll('.klimtec-plz__link').forEach((link) => {
        if (!link.dataset.baseHref) link.dataset.baseHref = link.getAttribute('href') || '';
        const base = link.dataset.baseHref;
        if (!base) return;
        if (base.charAt(0) === '#' || new URL(base, window.location.origin).origin !== window.location.origin) {
          link.setAttribute('href', base);
          return;
        }
        const [path, hash] = base.split('#');
        const glue = path.indexOf('?') === -1 ? '?' : '&';
        link.setAttribute('href', path + glue + 'plz=' + encodeURIComponent(plz) + (hash ? '#' + hash : ''));
      });
    }

    check() {
      const plz = this.input.value.trim();
      this.reset();

      if (plz.length < 5) {
        if (this.hint) this.hint.hidden = false;
        this.input.focus();
        return;
      }

      /* Laengster passender Praefix gewinnt. Die Staffel darf damit
         Zwei-, Drei- oder Fuenfsteller mischen: 21 fuer den Raum,
         216 fuer Buxtehude eine Zone weiter, und ein Fuenfsteller
         sticht beide. Vorher zaehlten nur die ersten zwei Stellen. */
      let match = null;
      let treffer = 0;
      this.zones.forEach((zone) => {
        String(zone.prefixes || '')
          .split(',')
          .map((value) => value.trim())
          .filter(Boolean)
          .forEach((p) => {
            if (plz.startsWith(p) && p.length > treffer) {
              treffer = p.length;
              match = zone;
            }
          });
      });

      if (match) {
        if (this.okTitle) this.okTitle.textContent = this.fill(this.dataset.okTitle, plz, match);
        if (this.okBody) this.okBody.textContent = this.fill(this.dataset.okBody, plz, match);
        if (this.ok) this.ok.hidden = false;
      } else {
        if (this.warnTitle) this.warnTitle.textContent = this.fill(this.dataset.warnTitle, plz, null);
        if (this.warn) this.warn.hidden = false;
      }

      this.carryPlz(plz);
    }
  }

  if (!customElements.get('klimtec-plz-check')) {
    customElements.define('klimtec-plz-check', KlimtecPlzCheck);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["klimtec-request-form"] && !Shopify.designMode) return;
  try {
    
  class KlimtecRequestForm extends HTMLElement {
    connectedCallback() {
      try {
        this.zones = JSON.parse(this.dataset.zones || '[]');
      } catch (error) {
        this.zones = [];
      }

      this.input = this.querySelector('[data-plz-input]');
      this.button = this.querySelector('[data-plz-submit]');
      this.hint = this.querySelector('[data-plz-hint]');
      this.ok = this.querySelector('[data-plz-ok]');
      this.warn = this.querySelector('[data-plz-warn]');
      this.okTitle = this.querySelector('[data-plz-ok-title]');
      this.okBody = this.querySelector('[data-plz-ok-body]');
      this.warnTitle = this.querySelector('[data-plz-warn-title]');
      this.locked = this.querySelector('[data-form-locked]');
      this.form = this.querySelector('[data-request-form]');
      this.city = this.querySelector('[data-city-input]');
      this.firstField = this.querySelector('[name="contact[Firma]"]');
      this.querySelectorAll('[data-jump]').forEach((btn) => btn.addEventListener('click', () => this.jumpToForm()));

      this.gated = this.dataset.gated === 'true';
      this.submitted = this.form ? this.form.querySelector('.klimtec-request__success') !== null : false;

      if (this.gated && !this.submitted) this.lock();

      if (!this.input || !this.button) return;

      this.button.addEventListener('click', () => this.check());

      this.input.addEventListener('input', () => {
        this.input.value = this.input.value.replace(/\D/g, '').slice(0, 5);
        this.resetResults();
      });

      this.input.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          this.check();
        }
      });

      this.presetFromUrl();
      this.focusOnAnchor();
    }

    /* Kommt der Besucher vom PLZ-Check der Startseite, steht die
       Postleitzahl als Parameter in der Adresse. Dann Feld fuellen und
       direkt pruefen, damit das Formular gleich offen ist. */
    /* Wer ueber den Anker herkommt, will anfragen. Dann gehoert der
       Cursor ins erste Feld. Ohne Anker nicht, sonst springt die Seite
       beim Laden und auf dem Handy oeffnet sich ungefragt die Tastatur. */
    focusOnAnchor() {
      const id = this.closest("[id]") ? this.closest("[id]").id : "";
      if (!id || window.location.hash !== "#" + id) return;
      if (this.input && this.input.value.trim() === "") {
        window.setTimeout(() => this.input.focus({ preventScroll: true }), 260);
      }
    }

    presetFromUrl() {
      const params = new URLSearchParams(window.location.search);
      const preset = String(params.get("plz") || "").replace(/\D/g, "").slice(0, 5);
      if (preset.length !== 5 || !this.input) return;
      this.input.value = preset;
      this.check();
    }

    lock() {
      if (this.form) this.form.hidden = true;
      if (this.locked) this.locked.hidden = false;
    }

    /* Auf breiten Displays steht das Formular direkt daneben, dort
       genuegt der Fokus. Auf schmalen liegt es unterhalb, dort scrollen
       wir zuerst hin. */
    jumpToForm() {
      if (!this.firstField) return;
      this.firstField.scrollIntoView({ behavior: 'smooth', block: 'center' });
      window.setTimeout(() => this.firstField.focus({ preventScroll: true }), 320);
    }

    unlock() {
      if (this.form) this.form.hidden = false;
      if (this.locked) this.locked.hidden = true;
    }

    resetResults() {
      [this.hint, this.ok, this.warn].forEach((element) => {
        if (element) element.hidden = true;
      });
    }

    fill(template, plz, zone) {
      return (template || '')
        .replace(/\{plz\}/g, plz)
        .replace(/\{zone\}/g, zone ? zone.label : '')
        .replace(/\{fee\}/g, zone ? zone.fee : '');
    }

    check() {
      const plz = this.input.value.trim();
      this.resetResults();

      if (plz.length < 5) {
        if (this.hint) this.hint.hidden = false;
        /* Zurueck ins Feld, damit die Korrektur ohne zweiten Tipp geht. */
        this.input.focus();
        return;
      }

      /* Laengster passender Praefix gewinnt. Die Staffel darf damit
         Zwei-, Drei- oder Fuenfsteller mischen: 21 fuer den Raum,
         216 fuer Buxtehude eine Zone weiter, und ein Fuenfsteller
         sticht beide. Vorher zaehlten nur die ersten zwei Stellen. */
      let match = null;
      let treffer = 0;
      this.zones.forEach((zone) => {
        String(zone.prefixes || '')
          .split(',')
          .map((value) => value.trim())
          .filter(Boolean)
          .forEach((p) => {
            if (plz.startsWith(p) && p.length > treffer) {
              treffer = p.length;
              match = zone;
            }
          });
      });

      if (match) {
        if (this.okTitle) this.okTitle.textContent = this.fill(this.dataset.okTitle, plz, match);
        if (this.okBody) this.okBody.textContent = this.fill(this.dataset.okBody, plz, match);
        if (this.ok) this.ok.hidden = false;
      } else {
        if (this.warnTitle) this.warnTitle.textContent = this.fill(this.dataset.warnTitle, plz, null);
        if (this.warn) this.warn.hidden = false;
      }

      if (this.city && this.city.value.trim() === '') this.city.value = plz + ' ';
      this.unlock();

      /* Ab 990 px liegt das Formular im Blickfeld, dann direkt hinein. */
      if (window.matchMedia('(min-width: 990px)').matches && this.firstField) {
        this.firstField.focus({ preventScroll: true });
      }
    }
  }

  if (!customElements.get('klimtec-request-form')) {
    customElements.define('klimtec-request-form', KlimtecRequestForm);
  }

  } catch(e) { console.error(e); }
})();
})();
